import React, { useEffect, useState } from 'react'
import { Button } from '@front/meshkit'
import '@front/meshkit/utility/os'

const DELAY_TIME = 3000

const getQueryParam = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(param)
}

const openApp = (appLink: string) => {
  window.location.href = decodeURIComponent(appLink)
}

const App: React.FunctionComponent = () => {
  const [appLink, setAppLink] = useState<string | false | null>(null)
  const [showButton, setShowButton] = useState<boolean>(false)

  useEffect(() => {
    const _appLink = getQueryParam('app')
    if (!_appLink) {
      return setAppLink(false)
    }

    const decodedAppLink = decodeURIComponent(_appLink)
    setAppLink(decodedAppLink)
  }, [])

  useEffect(() => {
    if (appLink) {
      openApp(appLink)
      setTimeout(() => setShowButton(true), DELAY_TIME)
    }
  }, [appLink])

  if (appLink === null) {
    return null
  }

  if (appLink === false) {
    return (
      <div className="w-full h-full flex justify-center items-center container m-auto p-4">
        <h1 className="headline-r">No app link provided.</h1>
      </div>
    )
  }

  return (
    <div className="w-full h-full gap-8 flex flex-col justify-center items-center container m-auto p-8">
      <h1 className="headline-r">Opening your wallet...</h1>
      {showButton && (
        <>
          <p className="body-r text-gray-50">
            If the wallet doesn&apos;t open automatically, click the button
            below.
          </p>
          <Button className="w-full" onClick={() => openApp(appLink)}>
            Open App
          </Button>
        </>
      )}
    </div>
  )
}

export default App
